<template>
      <img src="@/assets/btn_google_signin_light_normal_web@2x.png" @click="googleOauth" class="center-image m-b-10" />
</template>

<script>

import Vue from 'vue'
import firebase from 'firebase'
import { mapMutations } from 'vuex'

export default {
  name: 'ButtonGoogle',
  props: ['title'],
  data () {
    return {
      messageStorage: this.flash()
    }
  },
  methods: {

    ...mapMutations([
      'user/setOauthUser',
      'user/changeLoaderState'
    ]),

    googleOauth () {
      var provider = new firebase.auth.GoogleAuthProvider()
      this['user/changeLoaderState'](true)
      var that = this
      firebase.auth().signInWithPopup(provider).then(function (result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        // var token = result.credential.accessToken
        // The signed-in user info.
        that['user/changeLoaderState'](true)
        var user = result.user
        console.log(user)

        firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function (idToken) {
          that.$store.dispatch('user/oauthLogin', idToken).then((res) => {
            that.messageStorage.destroyAll()
            that.messageStorage.flash('Welcome ' + user.displayName, 'success')
            Vue.http.headers.common['Authorization'] = 'Bearer ' + res.data.access_token
            if (that.lookup) {
              that.$router.push({ name: 'lookup', query: { lookup: that.lookup } })
            } else {
              that.$router.push({ name: 'upload_leads' })
            }
            that['user/changeLoaderState'](false)
            // that.$router.go()
          }).catch((err) => {
            console.log(err)
            that.messageStorage.destroyAll()
            that.messageStorage.flash('Unexpected error, try again', 'error')
            that['user/changeLoaderState'](false)
          })
        }).catch(function (error) {
          // Handle error
          console.log(error)
          that['user/changeLoaderState'](false)
        })

        // ...
      }).catch(function (error) {
        // Handle Errors here.
        // var errorCode = error.code
        // var errorMessage = error.message
        // The email of the user's account used.
        // var email = error.email
        // The firebase.auth.AuthCredential type that was used.
        // var credential = error.credential
        that.messageStorage.destroyAll()
        that.messageStorage.flash('Could not sign-in with Google', 'error')
        console.log(error)
        that['user/changeLoaderState'](false)
        // ...
      })
    }
  },
  computed: {
    lookup: function () {
      return this.$store.state.user.lookup
    }
  }
}
</script>

<style lang="scss">
  span.label {
    font-family: serif;
    font-weight: normal;
  }
  span.icon {
    background: url('~@/assets/google-icon.png') transparent 5px 50% no-repeat;
    background-size: 20px 20px;
    display: inline-block;
    vertical-align: middle;
    width: 42px;
    height: 20px;
  }
  span.buttonText {
    display: inline-block;
    vertical-align: middle;
    padding-left: 20px;
    padding-right: 42px;
    font-size: 14px;
    font-weight: bold;
  }
  .center-image {
    cursor: pointer;
    display: block;
    margin: 0 auto;
    width: 50%;
  }
</style>
